.wrapper {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  font-size: var(--size-200);

  color: var(--text-muted);
}

.select {
  padding: var(--space-2xs) var(--space-xs);

  font-size: var(--size-200);

  color: var(--text);
  background-color: var(--field);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);

  cursor: pointer;
}
